import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeMap: Record<string, string> = {
  dashboard: 'Přehled',
  'growing-areas': 'Záhony',
  growth: 'Pěstování',
  batches: 'Výsadby',
  'plant-o-pedia': 'Plant-O-Pedia',
  tasks: 'Úkoly',
  settings: 'Nastavení',
  analytics: 'Analytika',
  pests: 'Škůdci',
  diseases: 'Choroby',
  species: 'Druhy',
  reservoirs: 'Nádrže',
  sensors: 'Čidla',
  controls: 'Ovládání',
  notifications: 'Upozornění',
  profile: 'Profil',
  new: 'Nový',
  edit: 'Upravit',
  history: 'Historie',
  recommendations: 'Doporučení',
  incidents: 'Incidenty',
  inventory: 'Sklad',
  logs: 'Protokoly',
  automation: 'Automatická péče',
  safety: 'Hlídači',
  violations: 'Incidenty',
  schedule: 'Plánovač',
  varieties: 'Odrůdy',
  journal: 'Deník',
  recipes: 'Recepty',
  'dosing-tables': 'Šablony',
  admin: 'Administrace',
  users: 'Uživatelé',
  devices: 'Zařízení',
  'hardware-metrics': 'Hardware',
  'audit-logs': 'Audit',
  dosing: 'Výživa rostlin',
  config: 'Konfigurace',
  'crop-plans': 'Plánování',
  branches: 'Záhony',
};

const isID = (str: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str) ||
  /^[0-9a-f]{24}$/i.test(str) ||
  (/^\d+$/.test(str) && str.length > 3); // Also handles numeric IDs if they are long enough to be metadata

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0 || pathnames[0] === 'dashboard') {
    return null;
  }

  return (
    <nav
      className="flex px-4 sm:px-6 py-3 bg-gray-50/50 dark:bg-white/5 border-b border-gray-100 dark:border-zinc-800"
      aria-label="Breadcrumb"
    >
      <ol className="flex items-center space-x-2 text-xs font-medium">
        <li>
          <Link
            to="/dashboard"
            className="text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors flex items-center gap-1"
          >
            <Home size={14} />
            <span className="hidden sm:inline">Domů</span>
          </Link>
        </li>

        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          let name = routeMap[value] || value;

          // Pokud je to ID a nemáme pro něj název, ukážeme "Detail"
          if (!routeMap[value] && isID(value)) {
            name = 'Detail';
          }

          return (
            <li key={to} className="flex items-center space-x-2">
              <ChevronRight size={14} className="text-gray-300 dark:text-zinc-600" />
              {last ? (
                <span className="text-gray-900 dark:text-white font-semibold">{name}</span>
              ) : (
                <Link
                  to={to}
                  className="text-gray-500 hover:text-primary-600 dark:text-zinc-400 dark:hover:text-primary-400 transition-colors"
                >
                  {name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
